import { Button } from 'components/buttons/Button';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useState } from 'react';
import { useTableActions } from './hooks';
import { useTableColumns } from './hooks/useTableColumns';
import { useTableData } from './hooks/useTableData';

import ic_accept_all from "assets/images/ic_accept_all.svg";
import ic_reject_all from "assets/images/ic_reject_all.svg";

import "assets/scss/billingPortal/modules/comActivation.scss";
import { isArrayNotEmpty } from 'functions';
import { Toaster } from 'components/notification/Toaster';

function ComActivation(props) {
    const [currentTabId, setCurrentTabId] = useState("pending");

    let tabsDetails = [
        {
            id: "pending",
            text: "Pending",
            filters: {
                requestStatus: "Pending"
            }
        },
        {
            id: "activated",
            text: "Activated",
            filters: {
                requestStatus: "Done"
            }
        },
        {
            id: "rejected",
            text: "Rejected",
            filters: {
                requestStatus: "Rejected"
            }
        },
    ];


    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");
    
    const {
        getData,
        data, 
        isDataLoading,
        totalRecords
    } = useTableData();

    const {
        selectedCOMs, setSelectedCOMs,

        setIsSingleUpdate,
        setSingleCOMDetail,

        isUpdatingMultiple,

        updatingSingleRowPos,
        isUpdateSuccessful,
        isRejecting,

        updateModal, setIsModalVisible
    } = useTableActions();

    const columns = useTableColumns({
        updatingSingleRowPos,
        isRejecting,
        currentTabId,
        setSingleCOMDetail,
        setIsModalVisible, setIsSingleUpdate,
    });

    return (
        <DashboardLayout
            headerTitle={"COM Activation"}

            bodyClassName={"com-activation"}
            body={(
                <>
                    {updateModal}

                    <GeneralTable
                        className={"com-activation__table"}
                        columns={columns}
                        data={data}

                        isTableRefreshRequired={isUpdateSuccessful}

                        getTableData={getData}

                        onRowSelectionChange={setSelectedCOMs}

                        outerTableHeader={() => {
                            return (
                                <div className={"table__headers"}>
                                    {/* Top Section */}
                                    <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                        {/* Title */}
                                        <div className={"headers__title tableHeaderTitle "}>
                                            List
                                        </div>

                                        {(currentTabId === "pending")? (
                                            <div className={"headers__actions d-flex"}>
                                                {/* Accept */}
                                                <Button
                                                    className={"actions__accept-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_ComInfo_Update)}
                                                    handleOnClick={() => {
                                                        if (isArrayNotEmpty(selectedCOMs)) {
                                                            setIsModalVisible(true);
                                                            setIsSingleUpdate(false);
                                                            isRejecting.current = false;
                                                        }
                                                        else {
                                                            Toaster({
                                                                type: "info",
                                                                msg: "Please select at least 1 COM"
                                                            })
                                                        }
                                                    }}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={isUpdatingMultiple && !isRejecting.current}
                                                >
                                                    <>
                                                        <img
                                                            className={"accept-all__icon"}
                                                            src={ic_accept_all}
                                                        />

                                                        <span className={"accept-all__text tableHeaderButtonText "}>Accept</span>
                                                    </>
                                                </Button>

                                                {/* Reject */}
                                                <Button
                                                    className={"actions__reject-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_ComInfo_Update)}
                                                    handleOnClick={() => {
                                                        if (isArrayNotEmpty(selectedCOMs)) {
                                                            setIsModalVisible(true);
                                                            setIsSingleUpdate(false);
                                                            isRejecting.current = true;
                                                        }
                                                        else {
                                                            Toaster({
                                                                type: "info",
                                                                msg: "Please select at least 1 COM"
                                                            })
                                                        }
                                                    }}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={isUpdatingMultiple && isRejecting.current}
                                                >
                                                    <>
                                                        <img
                                                            className={"reject-all__icon"}
                                                            src={ic_reject_all}
                                                        />

                                                        <span className={"reject-all__text tableHeaderButtonText "}>Reject</span>
                                                    </>
                                                </Button>
                                            </div>
                                        ):""}
                                    </div>
                                </div>
                            );
                        }}
                        
                        defaultFilter={{ requestStatus: "Pending" }}
                        tabsDetails={tabsDetails}
                        onTabIdChange={(tabId) => {
                            setCurrentTabId(tabId);
                        }}
                        defaultTabId={currentTabId}
                        isTabRequired

                        isTableDataLoading={isDataLoading}

                        isUsingPagination
                        totalRecords={totalRecords}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isCheckboxRequired={userPermissions?.Internal_ComInfo_Update && currentTabId === "pending"}
                        isCheckboxColumnFirst
                    />
                </>
            )}
        />
    );
}

export default ComActivation;